// @flow
import _ from 'lodash';

import type { TRootStore } from '../../types';

export const getWaiversList = (
	state: TRootStore
) => _.get(state, 'leagues.waiver_list.by_id', {});

export default getWaiversList;


// WEBPACK FOOTER //
// ./src/modules/selectors/league/getWaiversList.js